import { z } from "zod";

export const WALKIE_TALKIE_ENVELOPE_TYPES = {
	PRESENCE: "wt_presence",
	SPEAKER_CHANGED: "wt_speaker_changed",
	TALK_DENIED: "wt_talk_denied",
} as const;

export type WalkieTalkieEnvelopeType = (typeof WALKIE_TALKIE_ENVELOPE_TYPES)[keyof typeof WALKIE_TALKIE_ENVELOPE_TYPES];

export const WALKIE_TALKIE_TALK_DENIED_REASONS = {
	BUSY: "busy",
	NOT_CONNECTED: "not_connected",
} as const;

export type WalkieTalkieTalkDeniedReason = (typeof WALKIE_TALKIE_TALK_DENIED_REASONS)[keyof typeof WALKIE_TALKIE_TALK_DENIED_REASONS];

export const walkieTalkiePresenceMemberSchema = z.object({
	user_id: z.string(),
	display_name: z.string(),
	avatar_url: z.string().nullable(),
	joined_at: z.number().int().positive(),
});
export type WalkieTalkiePresenceMember = z.infer<typeof walkieTalkiePresenceMemberSchema>;

export const walkieTalkiePresenceSchema = z.object({
	type: z.literal(WALKIE_TALKIE_ENVELOPE_TYPES.PRESENCE),
	group_id: z.string(),
	members: z.array(walkieTalkiePresenceMemberSchema),
});
export type WalkieTalkiePresenceEnvelope = z.infer<typeof walkieTalkiePresenceSchema>;

export const walkieTalkieSpeakerChangedSchema = z.object({
	type: z.literal(WALKIE_TALKIE_ENVELOPE_TYPES.SPEAKER_CHANGED),
	group_id: z.string(),
	user_id: z.string().nullable(),
	display_name: z.string().nullable(),
	avatar_url: z.string().nullable(),
	started_at: z.number().int().positive().nullable(),
});
export type WalkieTalkieSpeakerChangedEnvelope = z.infer<typeof walkieTalkieSpeakerChangedSchema>;

export const walkieTalkieTalkDeniedSchema = z.object({
	type: z.literal(WALKIE_TALKIE_ENVELOPE_TYPES.TALK_DENIED),
	group_id: z.string(),
	reason: z.enum([WALKIE_TALKIE_TALK_DENIED_REASONS.BUSY, WALKIE_TALKIE_TALK_DENIED_REASONS.NOT_CONNECTED]),
});
export type WalkieTalkieTalkDeniedEnvelope = z.infer<typeof walkieTalkieTalkDeniedSchema>;

export const walkieTalkieEnvelopeSchemas = [
	walkieTalkiePresenceSchema,
	walkieTalkieSpeakerChangedSchema,
	walkieTalkieTalkDeniedSchema,
] as const;

export type WalkieTalkieServerEnvelope = WalkieTalkiePresenceEnvelope | WalkieTalkieSpeakerChangedEnvelope | WalkieTalkieTalkDeniedEnvelope;

export const WALKIE_TALKIE_CLIENT_FRAME_TYPES = {
	START_TALKING: "wt_start_talking",
	STOP_TALKING: "wt_stop_talking",
} as const;

export type WalkieTalkieClientFrameType = (typeof WALKIE_TALKIE_CLIENT_FRAME_TYPES)[keyof typeof WALKIE_TALKIE_CLIENT_FRAME_TYPES];

export const walkieTalkieStartTalkingSchema = z.object({
	type: z.literal(WALKIE_TALKIE_CLIENT_FRAME_TYPES.START_TALKING),
});
export type WalkieTalkieStartTalkingFrame = z.infer<typeof walkieTalkieStartTalkingSchema>;

export const walkieTalkieStopTalkingSchema = z.object({
	type: z.literal(WALKIE_TALKIE_CLIENT_FRAME_TYPES.STOP_TALKING),
});
export type WalkieTalkieStopTalkingFrame = z.infer<typeof walkieTalkieStopTalkingSchema>;

export const walkieTalkieClientControlEnvelopeSchema = z.discriminatedUnion("type", [
	walkieTalkieStartTalkingSchema,
	walkieTalkieStopTalkingSchema,
]);

export type WalkieTalkieClientControlEnvelope = z.infer<typeof walkieTalkieClientControlEnvelopeSchema>;
